export default "__VITE_ASSET__D1I3Tfjl__"